<script lang="ts">
	import { Router, Route } from "svelte-navigator";
	import Home from "./Home.svelte";
	import SignIn from "./account/SignIn.svelte";
	import { appManager } from "./AppManagerStore";
	import SignUp from "./account/SignUp.svelte";
	import ResetPassword from "./account/ResetPassword.svelte";
	import Blog from "./blog/Blog.svelte";
	import BlogPost from "./blog/BlogPost.svelte";
	import About from "./About.svelte";
	import Contact from "./Contact.svelte";
	import Newsletter from "./newsletter/Newsletter.svelte";
	import PrivateRoute from "./authentication/PrivateRoute.svelte";
	import Callback from "./authentication/Callback.svelte";
	import ConfirmEmail from "./account/ConfirmEmail.svelte";
	import {
		_,
		getLocaleFromNavigator,
		init,
		addMessages,
	} from "svelte-i18n";
	import en from "./locales/en.json";
	import nl from "./locales/nl.json";
	import Settings from "./account/settings/Settings.svelte";
	import SignOut from "./account/SignOut.svelte";
	import OrganizationSettings from "./organizations/settings/OrganizationSettings.svelte";
	import { Authenticator } from "./authentication/Authenticator";
	import { WebStorageStateStore } from "oidc-client";
	import Silent from "./authentication/Silent.svelte";
    import { IdentityApi } from "@anyways-open/identity-api-client";
    import Error from "./Error.svelte";
    import Head from "./header/Head.svelte";
    import NotFound from "./NotFound.svelte";
    import Organizations from "./admin/Organizations.svelte";
    import Users from "./admin/Users.svelte";
    import InviteUserModal from "./organizations/settings/InviteUserModal.svelte";
    import Pricing from "./pricing/Pricing.svelte";
    import CommunicateAddon from "./communicate/CommunicateAddon.svelte";
    import ForgotPassword from "./account/ForgotPassword.svelte";
    import NewsletterThanks from "./newsletter/NewsletterThanks.svelte";
    import AcceptInvite from "./organizations/settings/AcceptInvite.svelte";
    import Models from "./models/Models.svelte";
	import { TripsApi } from "@anyways-open/trips-api-client";
    import Buy from "./buy/Buy.svelte";
    import Terms from "./Terms.svelte";

	// Locale setup
	addMessages("en", en);
	addMessages("nl", nl);
	init({
		fallbackLocale: "en",
		initialLocale: getLocaleFromNavigator(),
	});

	const publicUrl = new URL("process.env.BASEURL");

	$appManager.TripsApi = new TripsApi({ 
		url: "process.env.TRIPS_API",
		key: ""
	});
	let authority = "process.env.AUTHORITY";
	if (authority !== "undefined") {
		$appManager.IdentityApi = new IdentityApi(authority);
	}

	let callbackUrl = publicUrl.href + "/callback";
	let silentUrl = publicUrl.href + "/silent";
	$appManager.PublicUrl = publicUrl.href + "/";
	if (publicUrl.href.endsWith("/")) {
		callbackUrl = publicUrl.href + "callback";
		silentUrl = publicUrl.href + "silent";
		$appManager.PublicUrl = publicUrl.href;
	}

	if (typeof $appManager.Authenticator === "undefined") {
		$appManager.Authenticator = new Authenticator({
			authority: "process.env.AUTHORITY",
			client_id: "website-webapp",
			redirect_uri: callbackUrl,
			post_logout_redirect_uri: `${publicUrl.href}`,
			silent_redirect_uri: silentUrl,
			response_type: "code",
			scope: "openid profile impact roles identity shortcut",
			automaticSilentRenew: true,
			monitorSession: false,
			checkSessionInterval: 20000,
			userStore: new WebStorageStateStore({
				prefix: "anyways",
				store: window.localStorage,
			}),
		});
	}
</script>

<InviteUserModal />

<Router basepath={publicUrl.pathname}>
	<Head />

	<Route path="/">
		<Home />
	</Route>
	<Route path="about">
		<About />
	</Route>
	<Route path="terms">
		<Terms />
	</Route>
	<Route path="models">
		<Models />
	</Route>
	<Route path="contact">
		<Contact />
	</Route>
	<Route path="buy">
		<Buy />
	</Route>
	<Route path="newsletter">
		<Newsletter />
	</Route>
	<Route path="newsletter/thanks">
		<NewsletterThanks />
	</Route>
	<Route path="communicate">
		<CommunicateAddon />
	</Route>
	<Route path="blog">
		<Blog />
	</Route>
	<Route path="pricing">
		<Pricing />
	</Route>
	<Route path="blog/:id" let:params>
		<BlogPost id={params.id} />
	</Route>
	<Route path="signin">
		<SignIn />
	</Route>
	<Route path="signup">
		<SignUp />
	</Route>
	<Route path="signout">
		<SignOut />
	</Route>
	<Route path="silent">
		<Silent />
	</Route>
	<Route path="forgotpassword">
		<ForgotPassword />
	</Route>
	<Route path="resetpassword">
		<ResetPassword />
	</Route>
	<Route path="confirmemail">
		<ConfirmEmail />
	</Route>
	<PrivateRoute path="organizations/invite/accept">
		<AcceptInvite />
	</PrivateRoute>
	<PrivateRoute path="settings">
		<Settings view="general" />
	</PrivateRoute>
	<PrivateRoute path="settings/organizations">
		<Settings view="organizations" />
	</PrivateRoute>
	<PrivateRoute path="settings/organizations/:id" let:params>
		<OrganizationSettings view="general" id={params.id} />
	</PrivateRoute>
	<PrivateRoute path="settings/organizations/:id/users" let:params>
		<OrganizationSettings view="users" id={params.id} />
	</PrivateRoute>
	<PrivateRoute path="admin/organizations" adminOnly={true}>
		<Organizations />
	</PrivateRoute>
	<PrivateRoute path="admin/users" adminOnly={true}>
		<Users />
	</PrivateRoute>

	<Route path="callback">
		<Callback />
	</Route>
	<Route path="error">
		<Error />
	</Route>
	<Route path="notfound">
		<NotFound />
	</Route>
</Router>

<style>
</style>
